module.exports = __webpack_public_path__ + "static/img/app_bg4.675643d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_bg4.jpg
// module id = fyyh
// module chunks = 0